import { render, staticRenderFns } from "./AiTemplate.vue?vue&type=template&id=323cac26&scoped=true&"
import script from "./AiTemplate.vue?vue&type=script&lang=js&"
export * from "./AiTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AiTemplate.vue?vue&type=style&index=0&id=323cac26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323cac26",
  null
  
)

export default component.exports